import { produce } from 'immer'
import Actions from '../actions'

const initialState = {
    firstName: null,
    lastName: null,
    email: null,
    npn: null,
    phone: null,
}

export default produce((draft, action) => {
    const { payload } = action

    switch (action.type) {
        case Actions.BROKER_DATA_UPDATED: {
            const { firstName, lastName, email, npn, phone } = payload
            draft.firstName = firstName
            draft.lastName = lastName
            draft.email = email
            draft.npn = npn
            draft.phone = phone
            break
        }
        default: {
            // Nothing to do
            break
        }
    }
}, initialState)
